import { defineMessages } from 'react-intl'

export default defineMessages({
  callToAction: { defaultMessage: 'Create your own {sth}' },
})
